import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import restClient from "restClients";

const CACHE_KEY = "cities_data";
const CACHE_DURATION = 300000;

const getCachedData = () => {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (Date.now() - parsed.timestamp < CACHE_DURATION) {
        return parsed.data;
      }
    }
  } catch {}
  return null;
};

const setCachedData = (data) => {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({
      data,
      timestamp: Date.now(),
    }));
  } catch {}
};

export const fetchCities = createAsyncThunk(
  "cities/fetchCities",
  async (_, { getState }) => {
    const { cities } = getState();
    if (cities.data && cities.data.length > 0) {
      return cities.data;
    }

    const cached = getCachedData();
    if (cached) {
      return cached;
    }

    const { data } = await restClient.get("/cities/v2/header");
    const citiesData = data.data;
    setCachedData(citiesData);
    return citiesData;
  }
);

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const citiesSlice = createSlice({
  name: "cities",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCities.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const selectCitiesData = (state) => state.cities.data;
export const selectCitiesLoading = (state) => state.cities.loading;

export default citiesSlice.reducer;
